import { NgClass } from "@angular/common";
import { Component, inject, Input, OnInit } from "@angular/core";
import { LanguageService } from "@app/shared/services/language.service";
import { Constants } from "@core/constants";
import { IonButton, IonLabel } from "@ionic/angular/standalone";
import { WA_WINDOW } from "@ng-web-apis/common";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { ModalService } from "@shared/services/modal.service";
import { PlanStateService } from "@shared/services/plan-state.service";

@Component({
  selector: "pa-language-selector",
  templateUrl: "./language-selector.component.html",
  styleUrls: ["./language-selector.component.scss"],
  imports: [NgClass, TranslateModule, IonButton, IonLabel],
})
export class LanguageSelectorComponent implements OnInit {
  @Input() theme: "dark" | "light" = "light";
  language!: string;
  languageLabel!: string;

  private readonly modalService = inject(ModalService);
  private readonly planStateService = inject(PlanStateService);
  private readonly translateService = inject(TranslateService);
  private readonly languageService = inject(LanguageService);
  private readonly window = inject<Window>(WA_WINDOW);

  ngOnInit(): void {
    this.language = this.languageService.getLanguage();
    this.languageLabel = this.language === Constants.LANGUAGE_EN ? Constants.LANGUAGE_NL : Constants.LANGUAGE_EN;
  }

  onLanguageSelect(): void {
    if (this.planStateService.isPlanModified()) {
      this.modalService
        .handleConfirmModal("general.confirm.confirmTitle", "general.confirm.confirmQuestion")
        .subscribe((result) => {
          result && this.toggleLanguage();
        });
    } else {
      this.toggleLanguage();
    }
  }

  toggleLanguage(): void {
    this.language = this.languageLabel;
    this.languageLabel = this.language === Constants.LANGUAGE_EN ? Constants.LANGUAGE_NL : Constants.LANGUAGE_EN;

    this.translateService.use(this.language).subscribe(() => {
      this.languageService.setLanguage(this.language);
      this.window.location.reload();
    });
  }
}
